import React from "react";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { useStyles } from "./style";
import { currentSelectedVehicleId, selectVehicleDetails } from "src/app-redux/vehicle/vehicleSlice";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import DrawerDetails from "./DrawerDetails";
import DrawerTrail from "./DrawerTrail";
import DrawerSlotChange from "./DrawerSlotChange";
import { drawerOpenedFor } from "src/app-redux/yard/yardSlice";

export interface IProps {
  isDrawerOpen: boolean;
  handleCloseDrawer: any;
}
interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1} style={{ marginTop: "10px" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function Drawer(props: IProps) {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const selectedVehicleId = useAppSelector(currentSelectedVehicleId);
  const currentVehicleDetails: any = useAppSelector(selectVehicleDetails);
  const redirectedFrom = useAppSelector(drawerOpenedFor);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  React.useEffect(() => {
    if (redirectedFrom.payload.yard.drawerOpenedFor === "vehicleNumber") setValue(2);
    else setValue(value);
  }, [redirectedFrom]);
  React.useEffect(() => {
    getVehicleDetailsByIdAction(selectedVehicleId);
  }, []);
  return (
    <>
      <CommonDrawer
        heading={
          currentVehicleDetails.vehicleDetail
            ? currentVehicleDetails.vehicleDetail?.containerNumber
            : ""
        }
        isOpen={props.isDrawerOpen}
        closeDrawer={() => {
          setValue(0);
          props.handleCloseDrawer();
        }}
        drawerWidth={450}
        iconCallBackFun={() => {
          dispatch(getVehicleDetailsByIdAction(selectedVehicleId));
        }}
        border={true}
      >
        <div className={classes.mainDrawer}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
              className={classes.DrawerTabs}
            >
              <Tab label="Details" {...a11yProps(0)} />
              <Tab label="Trail" {...a11yProps(1)} />
              <Tab className={"slotTab"} label="Slot Change" {...a11yProps(2)} />
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0} dir={theme.direction}>
            <DrawerDetails />
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <DrawerTrail />
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <DrawerSlotChange />
          </TabPanel>
        </div>
      </CommonDrawer>
    </>
  );
}
